// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f312c439","453":"0fcaaa48","455":"0d868c41"}[chunkId] + ".chunk.js";
};